import { useQuery } from '@tanstack/react-query';

export const NONCOMPLIANCE_ENDPOINT = '/api/v5/noncompliance';

export type SignFormProps = {
  signature: string;
  useCase: string;
  criminalRecordsAgreement: string;
};

export async function signForm(
  methodType: string,
  data: SignFormProps | null = null
) {
  const headers = new Headers({
    'content-type': 'application/x-www-form-urlencoded',
  });

  const response = await fetch(NONCOMPLIANCE_ENDPOINT, {
    method: methodType,
    body: new URLSearchParams({
      'compliance_agreement[signature]': data?.signature || '',
      'compliance_agreement[use_case]': data?.useCase || '',
      criminal_records_agreement: data?.criminalRecordsAgreement || '',
    }),
    headers,
  });

  if (response.ok) {
    const data = await response.json();
    return data;
  }
  return handleErrors(response);
}

export async function requestAutomatedRefund() {
  const headers = new Headers({
    'content-type': 'application/x-www-form-urlencoded',
  });

  const response = await fetch(`${NONCOMPLIANCE_ENDPOINT}/prohibited_use`, {
    method: 'GET',
    headers,
  });

  if (response.ok) {
    const data = await response.json();
    return data;
  }
  return handleErrors(response);
}

async function handleErrors(response: Response) {
  if (response.status === 400) {
    const data = await response.json();
    const message = data.message || data.errors[0];
    throw new Error(message);
  } else {
    throw new Error('An unexpected error occurred.');
  }
}

export function useSignForm(formData: SignFormProps) {
  return useQuery({
    queryKey: ['signForm'],
    queryFn: async () => {
      return await signForm('POST', formData);
    },
  });
}

export function useRequestAutomatedRefund() {
  return useQuery({
    queryKey: ['requestAutomatedRefund'],
    queryFn: async () => {
      return await requestAutomatedRefund();
    },
  });
}
